import { Menu, MenuItem } from "@mui/material";
import React, { useState } from "react";
import Icon from "../../icon/Icon";

const Healthandfitnessmenu = () => {
    const [anchorEl, setAnchorEl] = useState(null);  
    const openMenu = Boolean(anchorEl);  
    
    const handleMenuOpen = (event) => {
        setAnchorEl(event.currentTarget);
    };
    
    const handleMenuClose = () => {
        setAnchorEl(null);
    };

    return (
        <div>
            <button onClick={handleMenuOpen} className="bg-white text-sm font-medium hover:bg-primary rounded-full hover hover:text-white p-2 flex items-center gap-1">
                Health & Fitness
                <Icon name="arrowdown" layoutClass="h-4 w-4 stroke-2"/>
            </button>
            
            <Menu
                anchorEl={anchorEl}
                open={openMenu}
                onClose={handleMenuClose}
                elevation={1}
            >
                <MenuItem>Option 1</MenuItem>
                <MenuItem>Option 2</MenuItem>
                <MenuItem>Option 3</MenuItem>
                <MenuItem>Option 4</MenuItem>
            </Menu>
        </div>
    );
};

export default Healthandfitnessmenu;
